import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Sparkles, Lock } from "lucide-react";

function diasRestantes(fin) {
  if (!fin) return 0;
  const ms = new Date(fin).getTime() - Date.now();
  return Math.max(0, Math.ceil(ms / 86400000));
}

export default function TrialBanner() {
  const { tenant } = useAuth();
  const navigate = useNavigate();
  if (!tenant) return null;

  if (tenant.estado === "expirado") {
    return (
      <div className="mb-5 rounded-lg bg-[#7F1D1D] text-white px-4 py-3 flex flex-wrap items-center gap-3" data-testid="trial-banner-expirado">
        <Lock size={18} className="shrink-0" />
        <div className="text-sm font-semibold flex-1 min-w-0">Tu prueba ha expirado · cuenta en modo solo lectura. Tus datos siguen intactos.</div>
        <button onClick={() => navigate("/activar")} data-testid="banner-activar-expirado"
          className="shrink-0 rounded-md bg-white text-[#7F1D1D] px-4 py-2 text-xs font-bold hover:bg-white/90 transition-colors">Activar mi plan</button>
      </div>
    );
  }

  if (tenant.plan === "trial") {
    const n = diasRestantes(tenant.fecha_fin_trial);
    return (
      <div className="mb-5 rounded-lg bg-[#0E2A47] text-white px-4 py-3 flex flex-wrap items-center gap-3" data-testid="trial-banner">
        <Sparkles size={18} className="text-[#FF5625] shrink-0" />
        <div className="text-sm font-semibold flex-1 min-w-0">Prueba gratuita · quedan <b className="text-[#FF5625]">{n} día{n === 1 ? "" : "s"}</b></div>
        <button onClick={() => navigate("/activar")} data-testid="banner-activar"
          className="shrink-0 rounded-md bg-[#FF5625] hover:bg-[#E0451A] transition-colors px-4 py-2 text-xs font-bold">Activar mi plan</button>
      </div>
    );
  }
  return null;
}
